<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="close()">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75"/>

                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                                     enter-from="translate-x-full" enter-to="translate-x-0"
                                     leave="transform transition ease-in-out duration-500 sm:duration-700"
                                     leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen max-w-xl">
                            <form class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
                                  @submit.prevent="submit">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4  bg-gradient-to-b from-pitch-purple to-dark-pitch-purple sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white">
                                                <span v-if="supplier_invoice.fixture">
                                                    Supplier Invoice for {{ supplier_invoice.fixture.title }}
                                                </span>
                                                <span v-else>
                                                    Supplier Invoice for N/A
                                                </span>
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                        class="bg-dark-pitch-purple rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                        @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true"/>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <p class="text-sm text-indigo-300">
                                                Add a custom message to be included within the email.
                                            </p>
                                        </div>
                                    </div>
                                    <SlideOutErrors :show="showErrors === true"/>
                                    <div class="flex-1 flex flex-col justify-between">
                                        <div class="px-4 divide-y divide-gray-200 sm:px-6">
                                            <div class="mt-6 grid grid-cols-2 gap-4">
                                                <div class="col-span-2 justify-end">
                                                    <label for="invoice_number"
                                                            class="block text-sm text-gray-900 required">
                                                        Custom Message
                                                    </label>
                                                    <div class="mt-1">
                                                        <quill-editor content-type="html" v-model:content="form.email_message"
                                                          class="min-h-[150px] block w-full bg-white border border-gray-300 shadow-sm py-2 px-3"
                                                          theme="snow"></quill-editor>
                                                    </div>
                                                </div>
                                                <div class="col-span-2 flex justify-end">
                                                    <button type="submit"
                                                            class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-pitch-purple hover:bg-dark-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-500">
                                                        <span>Send Email</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="flex-shrink-0 px-4 py-4 flex justify-end">
                                    <button type="button"
                                            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                            @click="close()">
                                        Close
                                    </button>
                                </div>
                            </form>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {XIcon} from '@heroicons/vue/outline'
import SlideOutErrors from "@/Components/SlideOutErrors";
import {emitter} from "@/eventHub";
import {ref, reactive} from 'vue';
import supplierinvoice from '@/Store/modules/supplierinvoice';
import {useForm, usePage} from '@inertiajs/vue3'

export default {
    components: {
        SlideOutErrors,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        XIcon
    },
    props: {
        supplier_invoices: Object
    },
    setup(prop, context) {

        const show = ref(false)

        const supplier_invoice = ref(0);

        const emitter = emitter;

        const form = useForm({
            email_message: null
        })

        function close() {
            this.show = false;
        }

        function open(supplier_invoice) {
            this.supplier_invoice = supplier_invoice;
            this.show = true;
        }

        function submit() {
            console.log(this.supplier_invoice);
            this.form.post(route('frontend.fixture.supplier-invoice.invoice.send_supplier_invoice_email', [this.supplier_invoice.fixture.id, this.supplier_invoice.id]), {
                onSuccess: page => {
                    this.show = false;
                    this.showErrors = false;
                    this.form.reset();
                },
                onError: errors => {
                    this.showErrors = true;
                }
            });
        }

        return {
            show,
            close,
            open,
            emitter,
            submit,
            form,
            supplier_invoice
        }
    },
    mounted() {
        emitter.on('openEmailSupplierInvoiceSlideout', (supplier_invoice) => {
            this.open(supplier_invoice);
        });
    }
}
</script>
